module.exports = __webpack_public_path__ + "static/caffe_latte-4e5739e7eb22f96c659699878ac8c8a3.png";